import { Cohort } from 'root-constants'

export const SEPARATED_CHECKOUT_COHORTS: Cohort[] = [
  Cohort.LUVLY_INTRO_FAST,
  Cohort.LUVLY_CHAT,
  Cohort.LUVLY_INTRO4_SALE,
  Cohort.LUVLY_REF,
  Cohort.LUVLY_REF03,
  Cohort.LUVLY_REF4_TT,
  Cohort.LUVLY_AREF,
  Cohort.LUVLY_REF4,
  Cohort.LUVLY_PRINTABLE,
  Cohort.LUVLY_EMAIL_INTRO_FAST,
  Cohort.LUVLY_CANCEL_INTRO_FAST,
  Cohort.LUVLY_CANCEL_INTRO_1,
  Cohort.LUVLY_EMAIL_SALE,
  Cohort.LUVLY_INFLUENCERS,
  Cohort.LUVLY_INTRO_SALE,
]

export const CANCEL_OFFER_COHORTS: Cohort[] = [
  Cohort.LUVLY_CHAT,
  Cohort.LUVLY_INTRO4_SALE,
  Cohort.LUVLY_REF,
  Cohort.LUVLY_REF03,
  Cohort.LUVLY_REF4_TT,
  Cohort.LUVLY_REF4,
  Cohort.LUVLY_AREF,
  Cohort.LUVLY_PRINTABLE,
  Cohort.LUVLY_INTRO_FAST,
  Cohort.LUVLY_INTRO_SALE,
  Cohort.LUVLY_CHIN,
]

export const HIGH_PRICES_CHILD_COHORTS: string[] = [
  'luvly_aref4',
  'luvly_printable4',
]
